import React from 'react'
import LessonDetailPage from '../pages/LessonDetailPage'

class LessonPopup extends React.Component {
  componentDidCatch(error, info) {
    console.log('error - LessonPopup')
    console.log(error)
    console.log('info')
    console.log(info)
  }

  render() {
    return (
      <div className="popup-wrapper">
        <div className="popup-content">
          <LessonDetailPage isPopup />
        </div>
      </div>
    )
  }
}

export default LessonPopup



// WEBPACK FOOTER //
// ./src/browser/components/LessonPopup.js